import { render, staticRenderFns } from "./repository_overflow_menu.vue?vue&type=template&id=f639b4e0"
import script from "./repository_overflow_menu.vue?vue&type=script&lang=js"
export * from "./repository_overflow_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports